/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsRunListItem,
    EfsMelcoEfsModelsRunListItemFromJSON,
    EfsMelcoEfsModelsRunListItemFromJSONTyped,
    EfsMelcoEfsModelsRunListItemToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsRunListItem>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem
     */
    list: Array<EfsMelcoEfsModelsRunListItem>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsRunListItemFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem {
    return EfsMelcoModelsGenericList1MelcoEfsModelsRunListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsRunListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsRunListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsRunListItemToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsRunListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsRunListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


